<template>
  <div>
    <header-bar>著作権管理サービス</header-bar>
    <div class="page-block">
      <div class="page-block__inner">
        <div class="split-tabs">
          <button
            :class="firstTab ? 'c-btn tab-btn split-tab-active':'c-btn tab-btn split-tab-inactive'"
            @click="onFirstTabSelected">
            自分が管理者の作品
          </button>
          <button
            :class="secondTab ? 'c-btn tab-btn split-tab-active':'c-btn tab-btn split-tab-inactive'"
            @click="onSecondTabSelected">
            自分がゲストの作品
          </button>
          <div class="link_list">
            <router-link
              :to="{ name: 'faq-detail', params: { id: 220 } }"
              class="c-text-link link_element">
              著作権スプリットとは
            </router-link>
          </div>
        </div>
        <div class="my-release-search-wrap">
          <div class="my-release-search-text">リリース検索</div>
          <form @submit.prevent="onClickedSearch">
            <input
              v-model="preKeyword"
              class="my-release-search"
              type="search">
          </form>
          <a
            class="c-btn c-btn--search"
            @click.prevent="onClickedSearch">
            <img
              src="/img/common/icon-search.png"
              alt="">検索
          </a>
        </div>
      </div>
    </div>
    <template
      v-if="isOwner">
      <div
        ref="ownerPendingStatusBlock"
        class="page-block">
        <div class="page-block__heading page-block__heading--withbar">
          <h3 class="page-block__title">承認待ち</h3>
        </div>
        <div class="page-block__inner">
          <div class="c-table-caption">横にスクロールしてご覧ください</div>
          <div class="my-release-list">
            <split-owner-table
              ref="ownerPendingCopyrightSplitStatusTable"
              :status="pendingCopyrightSplitStatus"
              :keyword="keyword"
              :owner="isOwner"
              @on-pagination-clicked="scrollTo('ownerPendingStatusBlock')">
              <template v-slot:control1="slotProps">
                <button
                  class="c-btn mw-160"
                  @click.prevent="onDetailsClicked(slotProps.split)">
                  詳細を見る
                </button>
              </template>
              <template #empty>
                <span v-if="keyword">このキーワードの</span>承認待ちの著作権スプリットはありません。
              </template>
            </split-owner-table>
          </div>
        </div>
      </div>

      <div
        ref="ownerCancelStatusBlock"
        class="page-block">
        <div class="page-block__heading page-block__heading--withbar">
          <h3 class="page-block__title">キャンセル</h3>
        </div>
        <div class="page-block__inner">
          <div class="c-table-caption">横にスクロールしてご覧ください</div>
          <div class="my-release-list">
            <split-owner-table
              ref="ownerCancelCopyrightSplitStatusTable"
              :status="cancelCopyrightSplitStatus"
              :keyword="keyword"
              :owner="isOwner"
              @on-pagination-clicked="scrollTo('ownerCancelStatusBlock')">
              <template v-slot:control1="slotProps">
                <div
                  class="c-btn mw-160"
                  @click.prevent="onDetailsClicked(slotProps.split)">
                  詳細を見る
                </div>
              </template>
              <template #empty>
                <span v-if="keyword">このキーワードの</span>キャンセルされた著作権スプリットはありません。
              </template>
            </split-owner-table>
          </div>
        </div>
      </div>
      <div
        ref="completedStatusBlock"
        class="page-block">
        <div class="page-block__heading page-block__heading--withbar">
          <h3 class="page-block__title">完了</h3>
        </div>
        <div class="page-block__inner">
          <div class="c-table-caption">横にスクロールしてご覧ください</div>
          <div class="my-release-list">
            <split-owner-table
              ref="ownerCompletedCopyrightSplitStatusTable"
              :status="completedCopyrightSplitStatus"
              :keyword="keyword"
              :owner="isOwner"
              @on-pagination-clicked="scrollTo('completedStatusBlock')">
              <template v-slot:control1="slotProps">
                <button
                  class="c-btn mw-160"
                  @click.prevent="onDetailsClicked(slotProps.split)">
                  詳細を見る
                </button>
              </template>
              <template #empty>
                <span v-if="keyword">このキーワードの</span>完了した著作権スプリットはありません。
              </template>
            </split-owner-table>
          </div>
        </div>
      </div>
    </template>
    <template
      v-else>
      <div
        ref="guestPendingStatusBlock"
        class="page-block">
        <div class="page-block__heading page-block__heading--withbar">
          <h3 class="page-block__title">承認待ち</h3>
        </div>
        <div class="page-block__inner">
          <div class="c-table-caption">横にスクロールしてご覧ください</div>
          <div class="my-release-list">
            <split-guest-table
              ref="guestPendingCopyrightSplitStatusTable"
              :status="pendingCopyrightSplitStatus"
              :keyword="keyword"
              :owner="isOwner"
              @on-pagination-clicked="scrollTo('guestPendingStatusBlock')">
              <template #empty>
                <span v-if="keyword">このキーワードの</span>承認待ちの著作権スプリットはありません。
              </template>
            </split-guest-table>
          </div>
        </div>
      </div>
      <div
        ref="guestCancelStatusBlock"
        class="page-block">
        <div class="page-block__heading page-block__heading--withbar">
          <h3 class="page-block__title">キャンセル</h3>
        </div>
        <div class="page-block__inner">
          <div class="c-table-caption">横にスクロールしてご覧ください</div>
          <div class="my-release-list">
            <split-guest-table
              ref="guestCancelCopyrightSplitStatusTable"
              :status="cancelCopyrightSplitStatus"
              :keyword="keyword"
              :owner="isOwner"
              @on-pagination-clicked="scrollTo('guestCancelStatusBlock')">
              <template #empty>
                <span v-if="keyword">このキーワードの</span>キャンセルされた著作権スプリットはありません。
              </template>
            </split-guest-table>
          </div>
        </div>
      </div>
      <div
        ref="guestCompletedStatusBlock"
        class="page-block">
        <div class="page-block__heading page-block__heading--withbar">
          <h3 class="page-block__title">完了</h3>
        </div>
        <div class="page-block__inner">
          <div class="c-table-caption">横にスクロールしてご覧ください</div>
          <div class="my-release-list">
            <split-guest-table
              ref="guestCompletedCopyrightSplitStatusTable"
              :status="completedCopyrightSplitStatus"
              :keyword="keyword"
              :owner="isOwner"
              @on-pagination-clicked="scrollTo('guestCompletedStatusBlock')">
              <template #empty>
                <span v-if="keyword">このキーワードの</span>完了した著作権スプリットはありません。
              </template>
            </split-guest-table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import HeaderBar from '../../HeaderBar'
import SplitOwnerTable from './SplitOwnerTable'
import SplitGuestTable from './SplitGuestTable'
import {
  CMAP_COPYRIGHT_SPLIT_STATUS_PENDING_BEFORE_INVITATION,
  CMAP_COPYRIGHT_SPLIT_STATUS_PENDING_AFTER_INVITATION,
  CMAP_COPYRIGHT_SPLIT_STATUS_COMPLETED,
  CMAP_COPYRIGHT_SPLIT_STATUS_CANCELLED,
} from '../../../../consts/status'

export default {
  name: 'CopyrightSplits',
  components: {
    HeaderBar,
    SplitOwnerTable,
    SplitGuestTable,
  },
  data() {
    return {
      firstTab: true,
      secondTab: false,
      preKeyword: '',
      keyword: '',
      isOwner: true,
    }
  },
  computed: {
    pendingCopyrightSplitStatus() {
      return [
        CMAP_COPYRIGHT_SPLIT_STATUS_PENDING_BEFORE_INVITATION,
        CMAP_COPYRIGHT_SPLIT_STATUS_PENDING_AFTER_INVITATION,
      ]
    },
    cancelCopyrightSplitStatus() {
      return [
        CMAP_COPYRIGHT_SPLIT_STATUS_CANCELLED,
      ]
    },
    completedCopyrightSplitStatus() {
      return [
        CMAP_COPYRIGHT_SPLIT_STATUS_COMPLETED,
      ]
    },
  },
  mounted() {
    window.sessionStorage.setItem('copyright-split', JSON.stringify({}))
  },
  methods: {
    onFirstTabSelected() {
      this.preKeyword = ''
      this.isOwner = true
      this.firstTab = true
      this.secondTab = false
      if (this.keyword) {
        this.keyword = ''
      }
    },
    onSecondTabSelected() {
      this.preKeyword = ''
      this.isOwner = false
      this.secondTab = true
      this.firstTab = false
      if (this.keyword) {
        this.keyword = ''
      }
    },
    onClickedSearch() {
      this.keyword = this.preKeyword.toString()
    },
    onDetailsClicked(params) {
      const copyrightSplit = JSON.parse(window.sessionStorage.getItem('copyright-split'))
      copyrightSplit.copyrightId = params.id
      copyrightSplit.enableSecondTab = true
      window.sessionStorage.setItem('copyright-split', JSON.stringify(copyrightSplit))
      this.$router.push({ name: 'copyright-splits-detail', params: { id: params.id } })
    },
    scrollTo(elementName) {
      this.$refs[elementName].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    },
  },
}
</script>

<style scoped>
.split-tab-active {
  background-color: #34458D !important;
  color: #fff !important;
}
.split-tab-inactive {
  background-color: #e6e6e6 !important;
  color: #4b4b4b !important;
}

.link_list {
  margin-left: auto;
  margin-top: -30px;
}

@media screen and (max-width: 896px) {
  .link_list {
    order: -1;
    padding-top: 0;
    margin-top: 0;
    margin-left: 0;
    text-align: right;
    width: 100%;
  }
}
</style>
